import script from "./VPanelLayer.vue?vue&type=script&setup=true&lang=ts"
export * from "./VPanelLayer.vue?vue&type=script&setup=true&lang=ts"

import "./VPanelLayer.vue?vue&type=style&index=0&id=f610b108&lang=scss"

const __exports__ = script;

export default __exports__